import { Api } from "../config/request";

export default {
  getPresignedURL(payload) {
    return Api.post("/merchant_facade/upload_url", payload);
  },
  createMerchantFacadeEntry(payload) {
    return Api.put("/merchant_facade/upload/ack", payload);
  },
  getMerchantFacadePictures(queryParams) {
    return Api.get(`/merchant_facade/list${queryParams}`);
  },
  deleteMerchantFacadePictures(merchant_id) {
    const payload = {
      id: merchant_id,
    };
    return Api.post("/merchant_facade/delete", payload);
  },
};
